import script from "./TaxonTotalIncome9Percent.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxonTotalIncome9Percent.vue?vue&type=script&setup=true&lang=js"

import "./TaxonTotalIncome9Percent.vue?vue&type=style&index=0&id=69418f4d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69418f4d"]])

export default __exports__